import React from "react";
import Modal from 'react-modal';
import ScrollAnimation from 'react-animate-on-scroll';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTiktok, FaInfoCircle} from "react-icons/fa";
import { IoMdCloseCircleOutline } from 'react-icons/io';
import 'animate.css';
import speacersBg from "../../img/speacer-fon.jpg";
import DOMPurify from "dompurify";
import SpeacersFon from '../../img/speacer-fon.jpg'
import LiniesFon from '../../img/map_geo.svg';

// СоцСети
const SocialIcons = ({ fbLink, instLink, linkedinLink, tiktokLink, openModal }) => {
    const socialLinks = [
        { link: fbLink, icon: <FaFacebookF className="w-4 h-4 text-[#003581]" /> },
        { link: instLink, icon: <FaInstagram className="w-4 h-4 text-[#003581]" /> },
        { link: linkedinLink, icon: <FaLinkedinIn className="w-4 h-4 text-[#003581]" /> },
        { link: tiktokLink, icon: <FaTiktok className=" w-4 h-4 text-[#003581]" /> },
    ];

    return (
        <div className="absolute -left-[18px] -top-[10px] rounded-full z-[20] space-y-2 
            bg-[#E7EFFF] p-[3px] border-[3px] border-white box-content text-center "
        >
            {socialLinks.map((social, index) =>
                social.link ? (
                    <a
                        key={index}
                        href={social.link}
                        className="block bg-gray-200 rounded-full p-2 hover:bg-gray-300 transition "
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {social.icon}
                    </a>
                ) : null
            )}
            <button
                type="button"
                className="block bg-gray-200 rounded-full p-2 hover:bg-gray-300 transition"
                onClick={openModal}
            >
                <FaInfoCircle className="w-4 h-4 text-[#003581]" />
            </button>
        </div>
    );
};

// Модалка Спикера
const SpeakerModal = ({ speaker, isOpen, closeModal }) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            ariaHideApp={false}
            className="modal-container fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 flex justify-center items-center"
        >
            <button
                onClick={closeModal}
                className="absolute top-0 right-0 p-4 text-red-800 hover:text-red-600 focus:outline-none"
            >
                <IoMdCloseCircleOutline className="text-red-800 text-4xl" />
            </button>

            <div className="bg-white w-full max-w-4xl p-6 shadow-lg shadow-[#001D53] m-9 overflow-hidden">
                <div className="overflow-y-auto h-[80vh] max-h-max">
                <div className="flex flex-col md:flex-row items-center md:items-start">
                    <div className="mb-4 md:mb-0 md:w-4/12 overflow-hidden" style={{ backgroundImage: `url(${speacersBg})` }}>
                        <img
                            src={speaker.acf.sm_image}
                            alt={speaker.post_title}
                            className="w-full h-auto"
                        />
                    </div>
                    <div className="md:w-4/6 md:pl-6 w-full sm:w-auto">
                        <div className="mb-4 pb-4 border-b-2">
                            <h3 className="text-3xl font-semibold text-center md:text-left mb-3">{speaker.post_title}</h3>
                            {speaker.acf.logo && (
                                <img
                                    src={speaker.acf.logo}
                                    alt="Logo"
                                    className="object-contain w-16 mb-4 m-auto md:ml-0"
                                    style={{"width": speaker.acf.logo_mw + "px"}}
                                />
                            )}
                            <p className="text-sm text-center md:text-left text-gray-600">{speaker.acf.position}</p>
                        </div>
                        <div className="speacer-popup-info" dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(speaker.acf.info, {sanitize: true})}} />
                    </div>
                </div>
                </div>
            </div>
        </Modal>
    );
};

// Карточка Спикера
const SpeakerCard = ({ speaker }) => {
    const [modalIsOpen, setIsOpen] = React.useState(false);

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    return (
        <div className="bg-white shadow-lg flex flex-col items-center relative">
            {/*<div className="overflow-hidden rounded-t-2xl" style={{ backgroundImage: `url(${speacersBg})` }}>*/}
            <div className="overflow-hidden bg-[#5f35d4]" style={{background: 'url('+ SpeacersFon +')',backgroundSize: 'cover', backgroundPosition: 'center center'}}>
                <img
                    className="mx-auto w-full h-auto transition duration-[400ms wp-post-image]"
                    src={speaker.acf.sm_image}
                    alt={speaker.post_title}
                />
            </div>
            <div className="relative p-4 pt-0">
                {speaker.acf.logo ?
                    <div
                        className="relative -mt-[35px] w-[85px] h-[85px] mb-3 z-[9] lg:w-[74px] lg:h-[74px] flex justify-center bg-white p-3 shadow-lg mx-auto">
                        <img
                            src={speaker.acf.logo}
                            alt="Logo"
                            className="object-contain block w-full max-w-[50px]"
                            style={{"width": speaker.acf.logo_mw + "px"}}
                        />
                    </div> :
                    <div
                        className="relative -mt-[45px] mb-3 z-[9] w-[94px] h-[94px] flex justify-center bg-white p-3 shadow-lg mx-auto opacity-0">
                    </div>

                }
                <h3 className="text-lg mb-2 font-semibold text-center">{speaker.post_title}</h3>
                <p className="text-sm text-center text-gray-600">{speaker.acf.position}</p>
            </div>
            <button onClick={openModal} className="absolute w-full h-full z-[10]"></button>

            <SpeakerModal speaker={speaker} isOpen={modalIsOpen} closeModal={closeModal}/>

            <SocialIcons
                fbLink={speaker.acf.fb_link}
                instLink={speaker.acf.inst_link}
                linkedinLink={speaker.acf.linkedin_link}
                tiktokLink={speaker.acf.tiktok_link}
                openModal={openModal}
            />

            <div/>
        </div>
    );
};

// Основной компонент для отображения спикеров
const EventSpeakersBase = ({speacersData }) => {
    return (
        <>
            {speacersData && speacersData.length > 0 ? (
                <section className="py-10 mb-12 relative" id="speacers">
                    <div className="container w-[90%] max-w-screen-lg px-4 mx-auto">
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h2 className="sm:text-4xl text-2xl mb-9 uppercase title-design before:bg-[#dddddd] after:bg-[#dddddd]
                                ml-auto mr-auto w-fit"><span>Спікери 2026</span></h2>
                        </ScrollAnimation>
                    </div>
                    <div className="container max-w-screen-xl px-4 w-[90%] sm:w-full mx-auto z-30 relative">
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-6">
                            {speacersData.map((speaker, index) => (
                                <SpeakerCard key={index} speaker={speaker}/>
                            ))}
                        </div>
                    </div>

                </section>
            ) : null}
        </>
    );
};


export default EventSpeakersBase;
